module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/craters_layer_off-b944d760dbeac87ed8f0ccca76500415.png";